export default (params) => ({
  trigger: {
    name: 'product_plus.deselect_product_plus',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      list: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
        ],
      },
    },
    event: {
      name: 'remove_item',
    },
    nonInt: true,
  },
});
